import { Head } from "@shared/components/head";
import { View } from "react-native";
import { Text } from "@shared/components/text";
import { RouteProp, useRoute } from "@react-navigation/native";
import { activitySuccessContent } from "../constants";
import { dynamicTranslations } from "@shared/utils/dynamicTranslation";
import { TNavigationStackWithParams } from "app/types";
import { Button } from "@shared/components/md-design-system/Button/Button";
import { useNavigation } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { TNavigationStack } from "app/types";
import Icon from "@shared/components/md-design-system/Icon/Icon";
import { useActivitySequence } from "@shared/hooks";
import { TDrugSlot } from "../types";
import { TActivityBucket } from "../utils/activityCard";

const ActivitySuccessScreen = () => {
    const route = useRoute<RouteProp<TNavigationStackWithParams<{
        administered: boolean,
        activityId?: string,
        activityType?: 'drug' | 'questionnaire' | 'measurement',
        actualWindow?: TDrugSlot,
        prescribedWindow?: TActivityBucket,
    }>, 'ActivitySuccess'>>();
    const { administered, activityId = '', activityType, actualWindow, prescribedWindow } = route.params;
    const navigation = useNavigation<NativeStackNavigationProp<TNavigationStack>>();
    const { t } = dynamicTranslations();

    const { hasRemainingActivitiesInCurrentPeriod, navigateToNextOrHome } = useActivitySequence(activityId);

    const { title, description, showInfobox, infoboxPrescribedRange, confirmButtonKey } = activitySuccessContent({ administered, activityType, actualWindow, prescribedWindow });

    const handleContinue = () => {
        if (hasRemainingActivitiesInCurrentPeriod()) {
            navigateToNextOrHome();
        } else {
            navigation.navigate("Homepage");
        }
    }

    const buttonText = confirmButtonKey
        ? t(confirmButtonKey)
        : hasRemainingActivitiesInCurrentPeriod()
            ? t("measurement.nextActivity")
            : t("buttons.returnToMain");

    return (
        <View className="flex-1 flex-col justify-between">
            <View className="flex-1 flex-col items-center justify-center p-8 gap-4">
                <Icon name="check-circle" size={120} className="text-success-700" />
                <Head className="text-center" type={administered ? "h2" : "h1"}>{t(title)}</Head>
                {description && <Text className="text-center">{t(description)}</Text>}
                {showInfobox && infoboxPrescribedRange && (
                    <View className="bg-primary-100 border border-primary-100 rounded-2xl p-4 flex-row items-start gap-3">
                        <Icon name="info" size={18} className="text-primary-700" />
                        <Text className="flex-1 text-primary-700">
                            {t('screens.activities.drugsIntake.infobox', { range: infoboxPrescribedRange })}
                        </Text>
                    </View>
                )}
            </View>
            <View className="p-6">
                <Button onPress={handleContinue}>
                    {buttonText}
                </Button>
            </View>
        </View>
    )
}

export default ActivitySuccessScreen;